const services = [
  {
    title: "One-Page Landing Page",
    description:
      "A clean, fast single-page website to give your business a professional online presence. Mobile-friendly, fast-loading, and ready to go.",
    features: [
      "Single-page responsive design",
      "Contact form included",
      "Mobile-optimized",
      "Fast loading performance",
      "Live in 5-7 days",
    ],
    targetMessage:
      "Great for: Small businesses, freelancers, or anyone who needs a professional online presence.",
    displayCategory: "Website Packages",
    originalPrice: "$500",
    showInDropdown: true,
    order: 1,
    serviceType: "WEBSITE_CREATION",
    customIcon: "Layout",
  },
  {
    title: "Custom Website",
    description:
      "A fully custom multi-page website built from scratch for your specific needs. Scope and timeline depend on the project.",
    features: [
      "Multiple pages tailored to your business",
      "Custom design and layout",
      "Contact forms and integrations",
      "Mobile-first responsive design",
      "Timeline based on project scope",
    ],
    targetMessage:
      "For: Businesses that need more than a single page. Scope and pricing discussed during our call.",
    displayCategory: "Website Packages",
    originalPrice: "from $2,500",
    showInDropdown: true,
    order: 2,
    serviceType: "WEBSITE_CREATION",
    customIcon: "Code",
  },
  {
    title: "Managed Hosting",
    description:
      "We handle your hosting, security, and backups so you don't have to think about it.",
    features: [
      "Premium VPS hosting",
      "SSL certificate included",
      "Daily automated backups",
      "Two minor edits monthly",
      "48-hour support response",
    ],
    displayCategory: "Ongoing Support",
    originalPrice: "$100/mo",
    showInDropdown: false,
    order: 3,
    serviceType: "RECURRING",
    customIcon: "Server",
  },
];

export default services;
